<template>
  <DialogKit v-if="dialogStore.isOpen" :model-value="dialogStore.isOpen" @close="dialogStore.tryClose"
             :show-close-icon="dialogStore.isShowCloseIcon" ref="mainDialog" class="app-dialog">
    <div :class="{'pr-2': dialogStore.isNeedRightPadding && xs }" class="app-dialog-content d-flex flex-column" >
      <component :is="dialogStore.content?.component" v-bind="dialogStore.content?.props" v-if="dialogStore.content" />
    </div>
  </DialogKit>

  <v-dialog :model-value="dialogStore.isConfirmOpen" max-width="420" :opacity="0.65" :close-on-back="false" class="unsaved-confirmation"
            @update:model-value="onConfirmVisibilityChange">
    <v-card class="confirm-card" elevation="0">
      <div class="d-flex flex-column align-center">
        <v-icon size="40" :icon="InfoIcon" color="#FFCE31" class="mt-6"/>
        <div class="mt-2 mb-2 title">{{$t('Изменения не сохранены')}}</div>
        <div class="sub-title">{{$t('Все внесённые изменения не будут сохранены')}}</div>
        <v-checkbox v-model="notShowAgain" :label="$t('Больше не показывать')" class="mt-4 w-100"
                    v-if="dialogStore.isConfirmOpen && !dialogStore.notShowConfirmDialog && !dialogStore.forceConfirm"
                    :false-icon="FalseIcon" :true-icon="TrueIcon" hide-details></v-checkbox>
        <div class="confirm-actions">
          <v-btn variant="outlined" color="accent" rounded="lg" class="w-100 close mb-2" @click.stop="closeClick(true)">
            {{$t('Выйти без сохранения')}}
          </v-btn>
          <v-btn variant="outlined" color="accent" rounded="lg" class="w-100 mb-4" @click.stop="closeClick()">
            {{$t('Вернуться к редактированию')}}
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import {useDialogStore} from "@/stores/dialogStore.js";
import {onMounted, onUnmounted, ref, watch} from "vue";
import InfoIcon from "~/assets/icons/info.vue";
import TrueIcon from "~/assets/icons/checkbox/true.vue";
import FalseIcon from "~/assets/icons/checkbox/false.vue";
import {useDisplay} from "vuetify/framework";
import {trackDialogViewport} from '~/utils/dialogViewport'
const dialogStore = useDialogStore()
const notShowAgain = ref(false)
const {xs} = useDisplay();
const mainDialog = ref(null)
let stopViewportTracking: (() => void) | undefined

useHead(() => ({bodyAttrs: {class: dialogStore.isOpen || dialogStore.isConfirmOpen ? 'app-dialog-open' : ''}}))

const onConfirmVisibilityChange = (open: boolean) => {
  if (!open) dialogStore.cancelConfirm()
}

const handlePopState = () => {
  if (dialogStore.isOpen) {
    dialogStore.tryClose(true);
  }
};

const closeClick = (confirmed = false) => {
  if(confirmed) {
    dialogStore.confirm()
  } else {
    dialogStore.cancelConfirm()
  }

  if(notShowAgain.value && !dialogStore.notShowConfirmDialog && !dialogStore.forceConfirm) {
    dialogStore.setNotShowConfirmDialog(true)
  }
}

onMounted(() => {
  window.addEventListener("popstate", handlePopState);
  stopViewportTracking = trackDialogViewport(window, document)
});

onUnmounted(() => {
  window.removeEventListener("popstate", handlePopState);
  stopViewportTracking?.()
});

watch(() => dialogStore.isConfirmOpen, (showed) => {
  if (showed === true && mainDialog.value) {
    mainDialog.value.restoreHeight()
  }
})
</script>

<style scoped lang="sass">
// Outrank the UI-kit's scoped overlay rules without changing its source.
:global(html .overlay.overlay), :global(body .unsaved-confirmation)
  top: var(--dialog-viewport-top, 0px)
  left: var(--dialog-viewport-left, 0px)
  right: auto
  bottom: auto
  width: var(--dialog-viewport-width, 100%)
  height: var(--dialog-viewport-height, 100dvh)
:global(html .overlay.bottom .app-dialog.dialog-wrap)
  touch-action: auto
  padding-bottom: calc(8px + env(safe-area-inset-bottom, 0px))
:global(html .app-dialog .handle)
  touch-action: none
.app-dialog-content
  min-height: 0
  overflow-y: auto
  overscroll-behavior-y: contain
  -webkit-overflow-scrolling: touch
:global(html .app-dialog .create-page.home)
  height: auto !important
  flex: 0 0 auto !important
  margin-block: 0
@media (max-width: 599px)
  :global(.app-dialog .create-page)
    padding: 16px !important
:global(.app-dialog-open .rocketchat-widget:not(.app-chat-expanded))
  visibility: hidden !important
  pointer-events: none !important
:global(.unsaved-confirmation > .v-overlay__content)
  width: calc(100% - 16px)
  margin: 8px
.confirm-card
  padding: 24px
  border-radius: 16px !important
@media (max-width: 599px)
  .confirm-card
    padding: 16px
  .confirm-actions .v-btn
    padding: 0 16px
@media (max-width: 680px)
  :global(.dialog-wrap .auth-window)
    min-height: auto !important

.title
  color: #363636
  font-size: 20px
  font-weight: 600
  line-height: normal
  max-width: 180px
  text-align: center
.sub-title
  color: #363636
  font-size: 14px
  font-weight: 400
  line-height: normal
  max-width: 272px
  text-align: center
.confirm-actions
  width: 100%
  margin-top: 16px
.close
  color: #B20320!important
</style>
